/**
 * @file Drawer atom — edge-anchored panel overlay family.
 * @description structured atom: compound parts re-exported from the vendored
 * Gluestack family; this is the only sanctioned import path for app code
 * (RFC §3).
 * @module components/atoms/Drawer
 */
export {
  Drawer,
  DrawerBackdrop,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
} from "@/components/ui/drawer";

/*
 * ## The dimmed backdrop is DELIBERATE — it was removed and put back
 *
 * `DrawerBackdrop` animates to `opacity: 0.5` over `bg-surface-inverse`, which
 * greys out whatever sits behind the drawer.
 *
 * On 2026-08-06 that dimming was removed from the board's drawers (Add Players,
 * See All Pipelines, Activity Log) on the reasoning that those panels are read
 * ALONGSIDE the board, so washing the board out hides the very content the user
 * is consulting. Raniel saw both versions and chose the opposite: the dimming
 * helps FOCUS, and it went back the same day.
 *
 * Recorded here because the "keep the board readable" argument is a reasonable
 * one that will occur to the next person too — it was tried and decided, not
 * overlooked. If it comes up again it needs Raniel, not a code change.
 *
 * (A `DRAWER_BACKDROP_TRANSPARENT` constant lived here to express the
 * see-through variant. It was deleted with the revert rather than left behind:
 * an exported escape hatch with no callers reads as sanctioned and invites
 * exactly the change that was just reversed.)
 */
